export const FIELD_TYPE = {
  EDITABLE: "editable",
  COMPUTED: "computed",
  READ_ONLY: "readOnly",
};

export const fieldPassesSearch = (field, quickFilter) => {
  if (!quickFilter || quickFilter.trim() === "") return true;
  const q = quickFilter.toLowerCase();
  const labelStr = (field.label || "").toLowerCase();
  const termsStr = (field.searchTerms || "").toLowerCase();
  const valStr = (
    typeof field.value === "string" ? field.value : String(field.value ?? "")
  ).toLowerCase();
  return labelStr.includes(q) || termsStr.includes(q) || valStr.includes(q);
};

export const countVisibleFields = (fields, quickFilter) => {
  let visible = 0;
  for (const f of fields) {
    if (fieldPassesSearch(f, quickFilter)) visible++;
  }
  return { visible, total: fields.length };
};
